import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagement } from "../app/endpoints";
import axiosBaseQueryUserMangement from "./axiosBaseQueryUserMangement";

export const enumApi = createApi({
  reducerPath: "enumApi",
  baseQuery: axiosBaseQueryUserMangement({
    baseUrl: process.env.REACT_APP_USER_MANAGEMENT_BASE_URL,
  }),
  tagTypes: ["enum"],
  endpoints: (builder) => ({
    getEnumData: builder.mutation({
      query(body) {
        return {
          url: userManagement.enumController.getEnumData,
          method: "POST",
          body: {
            enumTypes: [
              "CANCELLATION_REASON",
              "AMENITIES_TYPE",
              "COMPANY_TYPE",
              "CONTACT_SUPPORT",
              "VEHICLE_AMENITIES_TYPE",
              "VEHICLE_TYPE",
              "PACKAGE_TYPE",
              "MAP_KEY",
            ],
          },
        };
      },
    }),
  }),
});

export const { useGetEnumDataMutation } = enumApi;
